import React from "react";

import Background from "../../../assets/dinner/dinner-select.png";
import ImageA from "../../../assets/dinner/dinner-option-a.png";
import ImageB from "../../../assets/dinner/dinner-option-b.png";

import GameSelectionLayout from "../GameSelectionLayout";

const DinnerPage2 = ({ setCurrentPage, setGarbageQtty }) => {
  const handleClickA = () => {
    setGarbageQtty((prev) => prev + 2);
    setCurrentPage("dinner-3");
  };

  const handleClickB = () => {
    setGarbageQtty((prev) => prev + 8);
    setCurrentPage("dinner-4");
  };

  return (
    <GameSelectionLayout
      bg={Background}
      imageA={ImageA}
      textA="만들어먹기"
      onClickA={handleClickA}
      imageB={ImageB}
      textB="포장해가기"
      onClickB={handleClickB}
      currentIndex={2}
    >
      떡볶이를 만들어 먹을까,
      <br />
      포장해 먹을까?
      <br />
      흠~
    </GameSelectionLayout>
  );
};

export default DinnerPage2;
